<template>
  <v-container fluid>
    <v-card>

      <v-card-title>

        <span class="headline hidden-xs-only">{{titulo}}</span>
        <v-btn class="ml-1 mr-1 " light ripple  icon="icon" @click.native="pesquisar()">
          <v-icon>refresh</v-icon>
        </v-btn>        

        <v-spacer class="hidden-xs-only"></v-spacer>
        <v-text-field
          append-icon="search"
          label="Pesquisar"
          single-line
          hide-details
          class="mr-1"
          v-model="search"
          v-on:keyup.enter="pesquisar()"
          ></v-text-field>

          <v-btn class="ml-1 mr-1 " dark ripple color="primary" title="Resultado PDF" icon="icon" @click.native="openPdf()" v-if="selected.length==1" >
            <v-icon>picture_as_pdf</v-icon>
          </v-btn>

          <v-btn class="ml-1 mr-1" dark ripple color="primary" title="Visualizador Web" icon="icon" @click.native="openViewer()" v-if="selected.length==1 && resultado.possuiImagem">
            <v-icon>collections</v-icon>
          </v-btn>

          <v-btn class="ml-1" title="Resultado Paciente" target="r" :href="linkResultado"  dark ripple color="primary" icon="icon" v-if="selected.length==1" >
            <v-icon>description</v-icon>
          </v-btn>

          <v-btn class="ml-1 mr-1" title="Cartão Paciente" target="c" :href="linkCartaoAcesso" dark ripple color="primary" icon="icon" v-if="selected.length==1">
            <v-icon>assignment_ind</v-icon>
          </v-btn>

          <v-btn class="ml-1 mr-1" title="Impressão Imagem" v-if="selected.length==1 && resultado.possuiImagem" dark ripple color="primary" icon="icon" @click.native="dialogImpressao = true" >
            <v-icon>print</v-icon>
          </v-btn>

          <v-btn class="ml-1" title="Excluir" dark ripple color="primary" icon="icon" slot="activator" @click.native="dialog=true" v-if="selected.length>0" >
            <v-icon>delete</v-icon>
          </v-btn>

      </v-card-title>
      <v-data-table
          v-bind:headers="headers"
          v-bind:items="items"
          v-model="selected"        
          selected-key="id"
          select-all
          :disable-initial-sort="true"
          :pagination.sync="pagination"
          :total-items="total"
          :loading="loading"          
          >
        <tr slot="items" slot-scope="props" :class="{ 'red lighten-4': props.item.idNovaVersao}">
          <td>
            <v-checkbox
            color="primary"
            hide-details
            v-model="props.selected"></v-checkbox>
          </td>
          <td>
            {{ moment(props.item.dataCadastro).calendar()}}
            <b class="red--text" v-if="props.item.idNovaVersao">
              Possui Nova Versão
            </b>
          </td>
          <td>{{ props.item.idExame }}</td>
          <td class="text">{{ props.item.nomePaciente }}</td>
          <td>{{ props.item.cpfPaciente }}</td>
          <td>{{ props.item.empresa.nome }}</td>
          <td>{{ props.item.dataAssinatura ? moment(props.item.dataAssinatura).format('DD/MM/YYYY hh:mm') : 'Sem Assinatura' }}</td>
          <td>{{ props.item.cpfAssinatura }}</td>

        </tr>
    </v-data-table>

      <v-dialog v-model="dialog" persistent  max-width="450">
        <v-card>
            <v-card-title>{{confirm.title}}</v-card-title>
            <v-card-text>{{confirm.contentHtml}}</v-card-text>
          <v-card-actions>
            <v-btn class="red--text darken-1" flat @click.native="dialog = false">{{confirm.cancel}}</v-btn>
            <v-btn class="green--text darken-1" flat @click.native="excluir()">{{confirm.ok}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        :timeout="timeoutAlerta"
        :color="tipoAlerta"
        v-model="snackbar">
        {{ textAlerta }}
        <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
      </v-snackbar>

      <PdfDialog :resultado="resultado" :link="linkPdf" :display.sync="dialogPdf"> </PdfDialog>
      <ViewerDialog :resultado="resultado" :link="linkViewer" :display.sync="dialogViewer"> </ViewerDialog>
      <impressao-dialog v-if="selected.length==1 && resultado.possuiImagem"  :resultado="resultado" :mostrar.sync="dialogImpressao" />


    </v-card>
  </v-container>

</template>

<script>

import PdfDialog from '@/components/PdfDialog'
import ViewerDialog from '@/components/ViewerDialog'
import ImpressaoDialog from '@/components/ImpressaoDialog'

import axios from 'axios'
import moment from 'moment'
moment.locale('pt-BR')

export default {
  name: 'resultados',
  data () {
    return {
      pagination: {
        sortBy: 'dataCadastro',
        descending: 'desc',
        page: 1,
        rowsPerPage: 10
      },
      loading: true,
      items: [],
      errors: [],
      total: null,
      titulo: 'Resultados',
      dialogPdf: false,
      dialogViewer: false,
      dialogImpressao: false,
      linkViewer: null,
      linkPdf: null,
      dialog: false,
      confirm: {
        title: 'Atenção',
        contentHtml: 'Tem certeza que deseja apagar os exame(s) selecionado(s).',
        ok: 'Sim',
        cancel: 'Não'
      },
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: '',
      search: '',
      selected: [],
      selectAll: '',
      headers: [
        {
          text: 'Cadastro',
          align: 'left',
          sortable: true,
          value: 'dataCadastro'
        },
        {
          text: 'Exame',
          align: 'left',
          sortable: true,
          value: 'idExame'
        },
        {
          text: 'Nome',
          align: 'left',
          sortable: true,
          value: 'nomePaciente'
        },
        { text: 'CPF',
          value: 'cpfPaciente',
          align: 'left'
        },
        { text: 'Empresa',
          value: 'cnpjEmpresa',
          align: 'left'
        },
        { text: 'Data Assinatura',
          value: 'dataAssinatura',
          align: 'left'
        },
        { text: 'Médico Assinatura',
          value: 'cpfAssinatura',
          align: 'left'
        }
      ]
    }
  },
  components: {
    PdfDialog,
    ViewerDialog,
    ImpressaoDialog
  },
  computed: {
    linkResultado () {
      var link = null
      var index = Object.keys(this.selected)[0]
      const res = this.selected[index]
      console.log(res)
      if (res) {
        link = `#/resultado/${res.id}`
      }
      return link
    },
    linkCartaoAcesso () {
      var link = null
      var index = Object.keys(this.selected)[0]
      const res = this.selected[index]
      console.log(res)
      if (res) {
        link = `#/cartao-acesso/${res.id}`
      }
      return link
    },
    /* linkPdf () {
      return 'https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/mezzow-desen/arquivo_signed.pdf'
    },
    linkViewer () {
      var link = null
      var index = Object.keys(this.selected)[0]
      const res = this.selected[index]
      console.log(res)
      if (res) {
        link = 'http://localhost/mviewer/index.html'
      }
      return link
    }, */
    resultado () {
      var index = Object.keys(this.selected)[0]
      const res = this.selected[index]
      console.log(res)
      return res
    }
  },
  watch: {
    search () {
      this.$store.commit('changeMedicoQuery', {query: this.search})
    },
    pagination: {
      handler () {
        this.atualizarLista()
      },
      deep: true
    }
  },
  methods: {
    moment (data) {
      return moment(data)
    },
    excluir () {
      var self = this
      Object.keys(this.selected).forEach((index) => {
        const resultado = this.selected[index]
        console.log('vai excluir ' + resultado.id)

        axios.delete(`/resultados/${resultado.id}`)
          .then(response => {
            self.atualizarLista()

            self.tipoAlerta = 'success'
            self.textAlerta = 'Resultado excluído com sucesso'
            self.snackbar = true
          })
          .catch(e => {
            self.tipoAlerta = 'error'
            self.textAlerta = 'Erro ao excluir resultado'
            self.snackbar = true

            console.log(e)
          })

        setTimeout(function () {
          self.selected = []
        }, 3000)

        this.dialog = false
      })
    },
    openPdf () {
      // var index = Object.keys(this.selected)[0]
      // const medico = this.selected[index]
      this.dialogPdf = true
      var link = null
      var index = Object.keys(this.selected)[0]
      const res = this.selected[index]
      if (res) {
        let idConnect = res.idConnect ? res.idConnect : 'laudos'
        if (res.dataAssinatura) {
          link = `https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/${res.intervaloStorage}/${idConnect}/${res.id}_signed.pdf`
        } else {
          link = `https://docs.google.com/viewer?embedded=true&url=https://storage.googleapis.com/${res.intervaloStorage}/${idConnect}/${res.id}_add.pdf`
        }
        this.linkPdf = link
      }
      // this.$router.push({name: 'MedicoEdit', params: { id: medico.id }})
    },
    detectmob () {
      if (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)) {
        return true
      } else {
        return false
      }
    },
    openViewer () {
      // var index = Object.keys(this.selected)[0]
      // const medico = this.selected[index]
      var index = Object.keys(this.selected)[0]
      const res = this.selected[index]
      console.log(res)
      if (res) {
        if (this.detectmob()) {
          link = `https://mviewer.mezzow.com/mindex.html?eid=${res.idConnect}&st=${res.intervaloStorage}&em=${res.email}`
          window.open(link, res.idConnect)
        } else {
          this.dialogViewer = true
          var link = null
          this.resultado = res
          link = `https://mviewer.mezzow.com/index.html?eid=${res.idConnect}&st=${res.intervaloStorage}&em=${res.email}`
          this.linkViewer = link
        }
      }
      // this.$router.push({name: 'MedicoEdit', params: { id: medico.id }})
    },
    editar () {
      var index = Object.keys(this.selected)[0]
      const medico = this.selected[index]
      this.$router.push({name: 'MedicoEdit', params: { id: medico.id }})
    },
    abrirCartao () {
      var index = Object.keys(this.selected)[0]
      const resultado = this.selected[index]
      this.$router.push({name: 'CartaoAcesso', params: { resultado: resultado.id }})
    },
    pesquisar () {
      this.pagination.page = 1
      this.atualizarLista()
    },
    atualizarLista () {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      var offset = (page - 1) * rowsPerPage
      var porPagina = rowsPerPage
      if (rowsPerPage !== -1 && rowsPerPage !== 5 && rowsPerPage !== 10 && rowsPerPage !== 25) {
        porPagina = 10
      }
      let order = 'desc'
      if (!descending) {
        order = 'asc'
      }
      axios.get(`/resultados?sort=${sortBy}&order=${order}&offset=${offset}&max=${porPagina}&q=${this.search}`)
        .then(response => {
          this.items = response.data.list
          this.total = response.data.total
          this.pagination.totalItems = response.data.total
          if (response.data.porPagina) {
            this.pagination.rowsPerPage = response.data.porPagina
          }
          this.loading = false
        })
        .catch(e => {
          this.errors.push(e)
        })
    }
  },

  // Fetches medicos when the component is created.
  created () {
    this.search = this.$store.state.medicoQuery
    // this.atualizarLista()
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .versao-antiga {
    background-color: yellow;
  }
  .text {
    text-transform: uppercase;  }
</style>



// WEBPACK FOOTER //
// ResultadoList.vue?4124e3ac